import {Card, CardActionArea, CardContent, Grid, Skeleton, Stack, Typography} from '@mui/material'
import React from 'react'

interface RcfaOverviewCardProps {
  count?: number
  isLoading?: boolean
  Icon: React.ElementType
  listLabel: string
  onClick?: () => void
}

export const RcfaOverviewCard = ({
  count,
  isLoading,
  Icon,
  listLabel,
  onClick
}: RcfaOverviewCardProps) => (
  <Grid item xs={6}>
    <Card
      sx={(theme) => ({
        boxShadow: '0px 2px 2px 0px #00000014',
        border: `1px solid ${theme.palette.divider}`
      })}
    >
      <CardActionArea onClick={onClick}>
        <CardContent
          sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5}}
        >
          {isLoading ? (
            <Skeleton variant="rounded" width={45} height={30} sx={{mb: 0.5}} />
          ) : (
            <Typography variant={'h1'} fontWeight={300}>
              {count}
            </Typography>
          )}

          <Stack direction="row" color="text.secondary" spacing={0.5}>
            <Icon sx={{fontSize: '16px'}} />
            <Typography variant="caption">{listLabel}</Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  </Grid>
)
